import { Helmet } from "react-helmet-async"
import { LeadsList } from "./../../Leads"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../Auth"

export default function Leads() {
	return (
		<>
			<Helmet>
				<title>Leads</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_TRIP_PLAN_REQUESTS}>
				<LeadsList />
			</ForbidUnlessAuthorized>
		</>
	)
}
